import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface DeleteOcrInvoiceAttachmentsRequest {
  attachmentIds: number[];
  moveAttachment: boolean;
  companyId: number;
}

const useDeleteOcrInvoiceAttachmentsApi = () => {
  const call = useCallback(
    (requestBody?: DeleteOcrInvoiceAttachmentsRequest) =>
      new Promise((resolve, reject) => {
        axiosInstance
          .post(api.deleteOcrInvoiceAttachments(), requestBody)
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    deleteOcrInvoiceAttachments: execute,
    isDeleteOcrLoading: isLoading,
  };
};

export default useDeleteOcrInvoiceAttachmentsApi;
